import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CWT_API_CONFIG, CWT_CACHE_CONFIG } from '@cawita/core-front/api';
import { CWT_ASSET_CONFIG } from '@cawita/core-front/asset';
import { CwtLoggedInGuard, CwtLoggedOutGuard, CWT_AUTH_CONFIG, JwtTokenInterceptor } from '@cawita/core-front/auth';
import { CwtLocalStorageProvider, CWT_STORAGE_PROVIDER } from '@cawita/core-front/storage';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { CrudModule } from '../../../frontend-shared/src/lib/modules/crud';
import { CwtLanguageModule } from '../../../frontend-shared/src/lib/modules/language';
import { ErrorInterceptor } from '../../../frontend-shared/src/lib/services/interceptors/error.interceptor';
import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import { PassportApiConfig, PassportAssetConfig, PassportAuthConfig, PassportCacheConfig } from './configs';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { fr_FR, NZ_I18N } from 'ng-zorro-antd/i18n';
import { NzIconModule } from 'ng-zorro-antd/icon';
import * as models from '@shared/models';

registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NzMessageModule,
    NzIconModule,
    RouterModule.forRoot([
      {
        path: 'auth',
        canActivate: [CwtLoggedOutGuard],
        loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthPageModule)
      },
      {
        path: '',
        canActivate: [CwtLoggedInGuard],
        loadChildren: () => import('./pages/main/main.module').then(m => m.MainPageModule)
      },
    ]),
    CrudModule.forRoot(models),
    CwtLanguageModule.forRoot({
      appName: 'Passport',
      default: 'fr',
      locales: ['fr', 'en'],
      storageKey: 'cwt-passport-language',
      translationFilePath: environment.translateFilePath
    })
  ],
  providers: [
    { provide: CWT_API_CONFIG, useValue: PassportApiConfig },
    { provide: CWT_AUTH_CONFIG, useValue: PassportAuthConfig },
    { provide: CWT_CACHE_CONFIG, useValue: PassportCacheConfig },
    { provide: CWT_ASSET_CONFIG, useValue: PassportAssetConfig },
    { provide: HTTP_INTERCEPTORS, useClass: JwtTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: CWT_STORAGE_PROVIDER, useClass: CwtLocalStorageProvider, },
    { provide: LOCALE_ID, useValue: 'fr'},
    { provide: NZ_I18N, useValue: fr_FR }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
